import { fetchApi } from "containers/helpers";

export const getStatistics = async (
	startDate = null,
	endDate = null
) => fetchApi(`/statistics${startDate !== null ? '?startDate=' + startDate : ''
	}${endDate !== null ? '&endDate=' + endDate : ''
	}
`);